import { useDestinationContext } from '@/src/contexts'

import ThingsToDo from './thingsToDo'

const ThingsToDoWrapper = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const things = sections.thingsToDo
    if (!things?.length) return null

    return <ThingsToDo things={things} />
}

export default ThingsToDoWrapper
